import React from "react";
import { DownloadUserProvider } from "./DownoadUserContext";

const DownloadUserPage = () => {
    return(
        <DownloadUserProvider>
            
        </DownloadUserProvider>
    )
};

export default DownloadUserPage;